export const objectToSearchParams = ob => {
	const query = new URLSearchParams();
	Object.keys(ob).map(key => {
		if (ob[key] !== undefined && ob[key] !== null && ob[key] !== '') {
			if (Array.isArray(ob[key])) {
				ob[key].map(v => query.append(key, v));
			} else {
				query.append(key, ob[key]);
			}
		}
	});
	return '?' + query.toString();
};
